import { createImmerReducer } from "core/legacy/reducers/createReducer";
import type { Org } from "legacy/constants/orgConstants";
import { ReduxActionTypes } from "legacy/constants/ReduxActionConstants";
import type { ReduxAction } from "legacy/constants/ReduxActionConstants";

const initialState: OrgReduxState = {
  currentOrg: {
    id: "",
    name: "",
  },
};

const orgReducer = createImmerReducer(initialState, (builder) =>
  builder.addCase(
    ReduxActionTypes.SET_CURRENT_ORG_ID,
    (
      draftState: OrgReduxState,
      action: ReduxAction<
        { orgId: string },
        typeof ReduxActionTypes.SET_CURRENT_ORG_ID
      >,
    ) => {
      draftState.currentOrg.id = action.payload.orgId;
    },
  ),
);

export interface OrgReduxState {
  currentOrg: Org;
}

export default orgReducer;
